import React, { useEffect, useRef, useState, useMemo } from "react";
import {
  Typography,
  Button,
  Card,
  DatePicker,
  Row,
  Col,
  Space,
  message,
  Divider,
  Modal,
  Radio,
  Drawer,
  Image,
  Spin,
  Table,
} from "antd";
import "./ProductDetailsCard.css";
import { ArrowRightOutlined, CloseOutlined } from "@ant-design/icons";
import { ReactComponent as CalenderIcon } from "../../../../assests/Mobile_calender_Icon.svg";
import dayjs from "dayjs";
import warningIcon from "../../../../assests/oops-warning-icon.svg";
import "./ProductDetailsVersion.css";
import { useLocation, useNavigate } from "react-router-dom";
import { API_BASE_URL_IMAGE } from "../../../../services/common";
import FloatingInput from "../../float-input/FloatInput";
import enUS from "antd/es/date-picker/locale/en_US";

import { useDispatch, useSelector } from "react-redux";
import {
  checkProductAvailabilityQuantity,
  checkProductAvailabilityQuantityBeforeLogin,
  createNewCampaign,
  getUserSavedCampaigns,
} from "../../../../store/thunks/buyer-thunks/BuyerThunks";
import {
  getSingleProductDetails,
  getSingleProductDetailsBeforeLogin,
} from "../../../../store/thunks/common-thunks/commonThunk";
import { formatToUSCurrency } from "../../utils/Utils";
import LoginAlert from "../../../modal/login-alert/LoginAlert";
const { Title, Text } = Typography;
const { RangePicker } = DatePicker;
const ProductDetailsCard = ({ productId, isBillboard }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const isCampaignsPage = location?.state?.isCampaignsPage;
  const [selectedCampaign, setSelectedCampaign] = useState("");
  const [selectedDates, setSelectedDates] = useState([]);
  const [selectedDatesForCampaign, setSelectedDatesForCampaign] = useState([]);
  const [openMobileCalendar, setOpenMobileCalendar] = useState(false);
  const [totalPrice, setTotalPrice] = useState();
  const [selectCampaignOpen, setSelectedCampaignOpen] = useState(false);
  const [selectedCampaignValue, setSelectedCampaignValue] = useState("");
  const [tempSelectedCampaign, setTempSelectedCampaign] = useState("");
  const [createNewCampaignModal, setCreateNewCampaignModal] = useState(false);
  const [warningPopup, setWarningPopup] = useState(false);
  const selectedCampaignId = localStorage.getItem("campaignId");
  const selectedCampaignName = localStorage.getItem("CampaignName");
  const { singleProduct, isLoading: productsLoader } = useSelector(
    (state) => state.products,
  );
  const product = singleProduct?.product_details;

  const {
    savedCampaigns,
    isLoading: buyerCampaignsLoader,
    productAvailabilityQuantity,
  } = useSelector((state) => state.buyerCampaigns);

  const isLoading = buyerCampaignsLoader || productsLoader;

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (productId && token) {
      dispatch(getSingleProductDetails(productId));
    } else if (productId && !token) {
      dispatch(getSingleProductDetailsBeforeLogin(productId));
    }
  }, [productId]);

  const sortedDates = [...selectedDates].sort(
    (a, b) => new Date(a) - new Date(b),
  );

  const formatDate = (timestamp) => {
    if (!timestamp) return ""; // or return "-"
    const date = new Date(parseInt(timestamp, 10));
    if (isNaN(date.getTime())) {
      return "";
    }
    return new Intl.DateTimeFormat("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
    }).format(date);
  };

  const customLocale = {
    ...enUS,
    lang: {
      ...enUS.lang,
      shortWeekDays: ["S", "M", "T", "W", "T", "F", "S"],
    },
  };
  const isLoggedIn = useSelector((state) => state.login.isAuthenticated);
  const startDate =
    selectedDatesForCampaign?.length > 0
      ? dayjs(selectedDatesForCampaign?.[0])?.format("MMM D, YYYY")
      : "";

  const [loginPopoverVisible, setLoginPopoverVisible] = useState(false);
  const datePickerRef = useRef(null);
  const [panelMonth, setPanelMonth] = useState(dayjs());

  const endDate =
    selectedDatesForCampaign?.length > 0
      ? dayjs(
          selectedDatesForCampaign?.[selectedDatesForCampaign?.length - 1],
        )?.format("MMM D, YYYY")
      : "";

  const [campaignName, setCampaignName] = useState("");
  const fromProductDate = formatDate(product?.from_date?.$date?.$numberLong);
  const toProductDate = formatDate(product?.to_date?.$date?.$numberLong);
  // Disabling the products as per the dates
  const disableProductDates = (current) => {
    const yesterday = dayjs()?.subtract(0, "day")?.startOf("day");
    if (!current) {
      return false;
    }
    // Disable previous dates
    if (current.isBefore(yesterday, "day")) {
      return true;
    }
    // Overall product range restriction
    if (
      (fromProductDate && current?.isBefore(dayjs(fromProductDate), "day")) ||
      (toProductDate && current?.isAfter(dayjs(toProductDate), "day"))
    ) {
      return true;
    }
    const fromDates = getDateValues(product?.from_date);
    const toDates = getDateValues(product?.to_date);
    // checking any current belonging the current slots dates
    const isWithinAnySlot = fromDates?.some((from, index) => {
      const startDate = dayjs(Number(from?.$date?.$numberLong));
      const endDate = dayjs(Number(toDates?.[index]?.$date?.$numberLong));
      return (
        current.isSame(startDate, "day") ||
        current?.isSame(endDate, "day") ||
        (current?.isAfter(startDate, "day") &&
          current?.isBefore(endDate, "day"))
      );
    });
    // disable remaining dates
    return !isWithinAnySlot;
  };

  const formatSize = (value) => {
    return value
      ?.replace(" feet", "'") // Convert feet to '
      ?.replace(" Line Inches", '"') // Convert inches to "
      ?.replace(" pixels", " px"); // Convert pixels to px
  };

  useEffect(() => {
    if (isBillboard) {
      setSelectedDates(
        Array.from(
          {
            length:
              dayjs(Number(product?.to_date?.$date?.$numberLong)).diff(
                dayjs(Number(product?.from_date?.$date?.$numberLong)),
                "day",
              ) + 1,
          },
          (_, i) =>
            dayjs(Number(product?.from_date?.$date?.$numberLong)).add(i, "day"),
        ),
      );
    }
  }, []);

  const dispatch = useDispatch();

  const [campaignId, setCampaignId] = useState("");
  const formattedDates = sortedDates?.map((date) => ({
    startDate: dayjs(date).startOf("day").toISOString(),
    endDate: dayjs(date).endOf("day").toISOString(),
  }));
  const [campaignDetails, setCampaignDetails] = useState({});
  const selectedCampaignDates = groupDateRanges(formattedDates);

  useEffect(() => {
    const [start, end] = selectedDates;
    if (start && end) {
      setOpenMobileCalendar(false);
    }
  }, [selectedDates]);

  const handleDateSelect = (dates) => {
    if (dates?.length === 2 && dates[0] && dates[1]) {
      const [start, end] = dates;
      if (start.isAfter(end)) {
        setSelectedDates([end, start]);
        setSelectedDatesForCampaign([end, start]);
      } else {
        setSelectedDates([start, end]);
        setSelectedDatesForCampaign([start, end]);
      }
    }
  };

  useEffect(() => {
    if (selectedDates[0]) {
      setPanelMonth(selectedDates[0]);
    }
  }, [selectedDates]);

  const handleSelect = (date) => {
    const [start, end] = selectedDates;
    if (!start && !end) {
      setSelectedDates([date, undefined]);
      return;
    }

    if (start && !end) {
      if (date.isBefore(start, "day")) {
        setSelectedDates([undefined, undefined]);
        setSelectedDatesForCampaign([undefined, undefined]);
      } else {
        setSelectedDates([start, date]);
        setSelectedDatesForCampaign([start, date]);
        if (!date.isSame(start, "day")) {
          setOpenMobileCalendar(false);
        }
      }
      return;
    }

    if (start && end) {
      if (date.isSame(end, "day")) {
        setSelectedDates([undefined, end]);
        setSelectedDatesForCampaign([undefined, end]);
      } else if (date.isBefore(end, "day")) {
        setSelectedDates([date, undefined]);
        setSelectedDatesForCampaign([date, undefined]);
      } else {
        setSelectedDates([start, date]);
        setSelectedDatesForCampaign([start, date]);
        if (!date.isSame(start, "day")) {
          setOpenMobileCalendar(false);
        }
      }
    }
    if (start && end && date.isSame(start, "day") && date.isSame(end, "day")) {
      setSelectedDates([undefined, undefined]);
      setSelectedDatesForCampaign([undefined, undefined]);
      return;
    }
  };

  const dateRender = (current) => {
    const isSameMonth =
      current.month() === (panelMonth?.month?.() ?? current.month());

    if (disableProductDates(current)) {
      return <div className="custom-cell disabled">{current.date()}</div>;
    }
    const [start, end] = selectedDates;
    const isStart = start && current.isSame(start, "day");
    const isEnd = end && current.isSame(end, "day");
    const className = [
      "custom-cell",
      isStart && isSameMonth && "start-date",
      isEnd && isSameMonth && "end-date",
    ]
      ?.join(" ")
      ?.trim();
    return (
      <div className={className} onClick={() => handleSelect(current)}>
        {current.date()}
      </div>
    );
  };

  useEffect(() => {
    if (
      selectedDatesForCampaign &&
      selectedDatesForCampaign.length > 0 &&
      selectedDatesForCampaign.every(Boolean)
    ) {
      const payload = {
        productId: product?.id,
        dates: `${selectedDatesForCampaign[0]?.format(
          "YYYY-MM-DD",
        )}/${selectedDatesForCampaign[1]?.format("YYYY-MM-DD")}`,
      };
      const token = localStorage.getItem("token");
      if (token) {
        dispatch(checkProductAvailabilityQuantity(payload));
      } else {
        dispatch(checkProductAvailabilityQuantityBeforeLogin(payload));
      }
    }
  }, [selectedDatesForCampaign]);

  function groupDateRanges(data) {
    const sortedData = data.sort(
      (a, b) => new Date(a.startDate) - new Date(b.startDate),
    );

    let currentGroup = [
      {
        startDate: sortedData[0]?.startDate,
        endDate: sortedData[1]?.endDate,
      },
    ];

    return currentGroup;
  }

  const displaySelectCampaignDrawer = () => {
    if (isLoggedIn) {
      if (
        selectedDates &&
        selectedDates.length > 0 &&
        productAvailabilityQuantity >= 1
      ) {
        dispatch(getUserSavedCampaigns());
        setSelectedCampaignOpen(true);
      } else {
        message.warning("Please select a date first!");
      }
    } else {
      setLoginPopoverVisible(true);
    }
  };
  const cancelSelectCampaignDrawer = () => {
    setTempSelectedCampaign(false);
    setSelectedCampaignOpen(false);
  };
  const handleSelectRadioChange = (e) => {
    setTempSelectedCampaign(e.target.value);
  };
  const handleSelectCampaignApply = () => {
    if (!tempSelectedCampaign) {
      return;
    }
    setSelectedCampaignValue(tempSelectedCampaign);
    setSelectedCampaignOpen(false);
  };
  const handleCreateNewCampaignModalOpen = () => {
    setSelectedCampaignOpen(false);
    setCreateNewCampaignModal(true);
  };
  const handleCreateNewCampaignModalCancel = () => {
    setCreateNewCampaignModal(false);
  };
  const handleNewCreateCampaignCancel = () => {
    setCreateNewCampaignModal(false);
  };
  const handleNewCreateCampaignConfirm = () => {
    if (campaignName.trim() !== "") {
      setSelectedCampaignValue(campaignName);
      const payload = {
        type: "new",
        name: campaignName,
        product_id: product?.id,
        dates: selectedCampaignDates,
        quantity: 1,
      };
      setCampaignDetails(payload);
      setCreateNewCampaignModal(false);
    }
  };
  const handleMenuItemClick = (campaignId, campaignName) => {
    setCampaignId(campaignId);
  };
  const handleAddCampaign = async () => {
    if (!selectedCampaignValue || !selectedDates) {
      setWarningPopup(true);
    } else {
    }
    try {
      const activeCampaignId = campaignId || selectedCampaignId;
      const payload = activeCampaignId?.length
        ? {
            type: "existing",
            product_id: product?.id,
            dates: selectedCampaignDates,
            campaign_id: activeCampaignId,
            quantity: 1,
          }
        : campaignDetails;
      if (isLoggedIn) {
        await dispatch(createNewCampaign(payload)).unwrap();
        message.success("Campaign created successfully!");
        navigate(-1);
        setSelectedDates([]);
      }
    } catch (error) {
      message.error(error || "Failed to create campaign. Please try again.");
    }
  };
  const minimumdays = product?.minimumdays || 0;
  const handleCountOfDates = () => {
    const value =
      selectedDatesForCampaign?.length >= 2 &&
      selectedDatesForCampaign[selectedDatesForCampaign?.length - 1]?.diff(
        selectedDatesForCampaign?.[0],
        "day",
      ) +
        1 >=
        minimumdays
        ? `${
            selectedDatesForCampaign?.[
              selectedDatesForCampaign?.length - 1
            ]?.diff(selectedDatesForCampaign?.[0], "day") + 1
          } `
        : "-";

    return value;
  };

  const calculateTotalPrice = ({
    price,
    productType,
    selectedDays,
    minimumDays,
  }) => {
    const oneDayPrice = price / 28;
    let totalPrice = 0;

    if (productType === "variable") {
      totalPrice =
        Number(selectedDays) >= Number(minimumDays)
          ? Number(selectedDays) * Number(oneDayPrice)
          : Number(minimumDays) * Number(oneDayPrice);
    } else if (productType === "fixed") {
      if (Number(selectedDays) >= Number(minimumDays)) {
        const roundFactor = Math.ceil(
          Number(selectedDays) / Number(minimumDays),
        ); // Round up to next whole
        const totalDays = roundFactor * Number(minimumDays);
        totalPrice = totalDays * Number(oneDayPrice);
      } else {
        totalPrice = Number(minimumDays) * Number(oneDayPrice);
      }
    }

    return Math.round(totalPrice);
  };
  useEffect(() => {
    if (isCampaignsPage) {
      setSelectedCampaign(campaignName);
    } else {
      setSelectedCampaign(null);
    }
  }, [isCampaignsPage]);

  useEffect(() => {
    handleCountOfDates();
    const productdetails = {
      price: product?.default_price || 0,
      productType: product?.fix?.toLowerCase(),
      selectedDays: handleCountOfDates(),
      minimumDays: product?.minimumdays || 0,
    };

    let v = calculateTotalPrice(productdetails);

    setTotalPrice(v);
  }, [selectedDates, product]);
  // Helper to converting the dates
  const getDateValues = (dateField) => {
    if (Array.isArray(dateField)) {
      return dateField;
    }
    return dateField ? [dateField] : [];
  };
  const fromDates = getDateValues(product?.from_date);
  const toDates = getDateValues(product?.to_date);
  const fromTimestamps = fromDates?.map((date) =>
    Number(date?.$date?.$numberLong),
  );
  const toTimestamps = toDates?.map((date) => Number(date?.$date?.$numberLong));
  const minFromDate = formatDate(Math?.min(...fromTimestamps));
  const maxToDate = formatDate(Math?.max(...toTimestamps));
  const tableData = React.useMemo(() => {
    if (!product) return [];

    const fromDates = getDateValues(product?.from_date);
    const toDates = getDateValues(product?.to_date);
    const quantities = Array.isArray(product?.unitQty) ? product.unitQty : [];

    return fromDates.map((from, index) => ({
      key: index,
      startDate: dayjs(Number(from?.$date?.$numberLong)).format("MMM DD, YYYY"),
      endDate: dayjs(Number(toDates?.[index]?.$date?.$numberLong)).format(
        "MMM DD, YYYY",
      ),
      quantity:
        product?.type === "Digital"
          ? (quantities[index] ?? "-")
          : product?.unitQty || "-",
    }));
  }, [product]);
  const tableColumns = [
    {
      title: "Start Date",
      dataIndex: "startDate",
      key: "startDate",
    },
    {
      title: "End Date",
      dataIndex: "endDate",
      key: "endDate",
    },
    ...(product?.type === "Digital" || product?.unitQty
      ? [
          {
            title: "Quantity",
            dataIndex: "quantity",
            key: "quantity",
            align: "center",
          },
        ]
      : []),
  ];
  const totalDays = useMemo(() => {
    if (!product) return 0;

    const fromDates = getDateValues(product?.from_date);
    const toDates = getDateValues(product?.to_date);

    return fromDates.reduce((acc, from, index) => {
      const start = dayjs(Number(from?.$date?.$numberLong));
      const end = dayjs(Number(toDates?.[index]?.$date?.$numberLong));

      return acc + end.diff(start, "day") + 1;
    }, 0);
  }, [product]);
  return (
    <>
      <div>
        <div className="product-details-main-div">
          <Card className="product-availabale-card">
            <Text className="product-id">{product?.siteNo}</Text>
            <div className="product-data-div">
              <Title level={4} className="product-title">
                {product?.title}
              </Title>
              <Text className="product-available-from">Available from</Text>
              <div className="available-dates-div">
                <Text className="product-available-dates">
                  {minFromDate}
                  <ArrowRightOutlined className="product-date-arrow-outlined" />
                  {maxToDate}
                </Text>
              </div>
            </div>
          </Card>
          <div className="no-of-selected-days-card">
            <Card>
              <Row align="middle" gutter={16}>
                <Col span={18}>
                  <Row>
                    <Col span={24}>
                      <Text className="no-of-selected-days-heading">
                        No. of Days Selected
                        <br />
                        {totalDays} Days
                      </Text>
                    </Col>
                  </Row>
                  <Row>
                    {!isBillboard ? (
                      <Col span={24}>
                        <Text className="selected-days">
                          {`${
                            selectedDatesForCampaign?.[
                              selectedDatesForCampaign?.length - 1
                            ]?.diff(selectedDatesForCampaign?.[0], "day") + 1 ||
                            0
                          } Days`}
                          {startDate &&
                            endDate &&
                            `(${startDate} - ${endDate})`}
                        </Text>
                      </Col>
                    ) : (
                      <Col span={24}>
                        <div>
                          <Table
                            columns={tableColumns}
                            dataSource={tableData}
                            pagination={false}
                            rowKey="key"
                            size="small"
                            className="billboard-table"
                          />
                        </div>
                      </Col>
                    )}
                  </Row>
                </Col>

                <Col span={6} className="calendar-container">
                  {isBillboard ? (
                    <>
                      <DatePicker
                        locale={customLocale}
                        className="custom-calendar-mobile"
                        ref={datePickerRef}
                        mode="date"
                        open={openMobileCalendar}
                        superNextIcon={false}
                        superPrevIcon={false}
                        placeholder=""
                        multiple
                        dropdownClassName="custom-calendar-popup-mobile"
                        disabledDate={disableProductDates}
                        value={
                          isBillboard
                            ? (() => {
                                const fromDates = getDateValues(
                                  product?.from_date,
                                );
                                const toDates = getDateValues(product?.to_date);
                                return fromDates.flatMap((from, index) => {
                                  const startDate = dayjs(
                                    Number(from?.$date?.$numberLong),
                                  );
                                  const endDate = dayjs(
                                    Number(
                                      toDates?.[index]?.$date?.$numberLong,
                                    ),
                                  );
                                  const totalDays =
                                    endDate?.diff(startDate, "day") + 1;
                                  return Array?.from(
                                    { length: totalDays },
                                    (_, i) => startDate.add(i, "day"),
                                  );
                                });
                              })()
                            : undefined
                        }
                      />
                      <CalenderIcon
                        className="calender-icon"
                        onClick={() =>
                          setOpenMobileCalendar(!openMobileCalendar)
                        }
                      />
                    </>
                  ) : (
                    <div className="disables-dates-div">
                      <CalenderIcon
                        onClick={() =>
                          setOpenMobileCalendar(!openMobileCalendar)
                        }
                        className="calender-icon"
                      />
                      <RangePicker
                        locale={customLocale}
                        className="custom-calendar-mobile disable-input-click"
                        popupClassName="custom-calendar-popup custom-calendar-popup-css custom-calender-arrows"
                        ref={datePickerRef}
                        open={openMobileCalendar}
                        superNextIcon={false}
                        superPrevIcon={false}
                        format="YYYY-MM-DD"
                        value={selectedDates.length === 2 && selectedDates}
                        onPanelChange={(value) => setPanelMonth(value[0])}
                        dateRender={(current) => dateRender(current)}
                        onCalendarChange={handleDateSelect}
                        onChange={() => {}}
                        disabledDate={disableProductDates}
                      />
                    </div>
                  )}
                </Col>
              </Row>
            </Card>
          </div>
          {!isBillboard && (
            <div
              className="product-saved-campaign-card "
              onClick={displaySelectCampaignDrawer}
            >
              <Card>
                <Row align="middle" gutter={16}>
                  <Col>
                    <Row>
                      <Col span={24}>
                        <Text className="select-campaign-heading">
                          Select the Campaign
                        </Text>
                      </Col>
                    </Row>
                    <Row>
                      <Col span={24}>
                        <Text className="campaign-list">
                          {isCampaignsPage
                            ? selectedCampaignValue ||
                              selectedCampaignName ||
                              "-"
                            : "-"}
                        </Text>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Card>
            </div>
          )}

          <div className="select-campaign-drawer-div">
            <Divider className="campaign-divider-mobile" />
            <Drawer
              title={
                <div className="select-campaign-drawer-title">
                  Select Campaign
                </div>
              }
              placement="bottom"
              closable={false}
              open={selectCampaignOpen}
              className="campaign-drawer-mobile"
              width="430px"
              extra={
                <div className="">
                  <CloseOutlined
                    className="custom-close-btn"
                    onClick={cancelSelectCampaignDrawer}
                  />
                </div>
              }
            >
              <div className="select-campaign-container">
                <div className="select-campaign-existing-list">
                  <Radio.Group
                    className="campaign-radio-btn-grp"
                    onChange={handleSelectRadioChange}
                    value={tempSelectedCampaign}
                  >
                    <div className="radio-list">
                      {savedCampaigns !== null && savedCampaigns?.length > 0 ? (
                        savedCampaigns?.map((campaign, index) => (
                          <div className="radio-item" key={campaign.id}>
                            <span className="select-campaign-existing-list-text">
                              {`${campaign.name} (${campaign.cid})`}
                            </span>
                            <Radio
                              value={campaign.id}
                              className="select-campaign-existing-list-rdio-btn"
                              onClick={() =>
                                handleMenuItemClick(campaign.id, campaign.name)
                              }
                            />
                          </div>
                        ))
                      ) : (
                        <p>No campaigns available</p>
                      )}
                    </div>
                  </Radio.Group>
                </div>
                <div className="select-campaign-footer">
                  <div className="select-campaign-footer-btn">
                    <Button
                      type="primary"
                      className="select-campaign-apply-btn"
                      onClick={handleSelectCampaignApply}
                    >
                      <span className="select-campaign-apply-btn-text">
                        Apply
                      </span>
                    </Button>
                  </div>
                  <div className="create-new-btn-parent">
                    <Button
                      type="primary"
                      className="mobile-create-new-campaign-btn"
                      onClick={handleCreateNewCampaignModalOpen}
                    >
                      <span className="mobile-create-new-campaign-btn-text">
                        Create New Campaign
                      </span>
                    </Button>
                  </div>
                </div>
              </div>
            </Drawer>
            <div>
              <Modal
                title={
                  <div className="create-new-campaign-tittle">
                    Create New Campaign
                  </div>
                }
                className="create-new-campaign-model"
                open={createNewCampaignModal}
                onCancel={handleCreateNewCampaignModalCancel}
                footer={null}
                closable={false}
                centered
              >
                <FloatingInput
                  label={"Enter Campaign Name*"}
                  value={campaignName}
                  onChange={(e) => setCampaignName(e.target.value)}
                  customStyles={{
                    "--input-border-color-focused": "#D2042D",
                    "--input-border-color": "#333333",
                  }}
                />
                <div>
                  <Row
                    gutter={16}
                    justify="center"
                    className="create-new-campaign-row"
                  >
                    <Col span={12} className="create-new-capaign-col-cancel">
                      <Button
                        type="primary"
                        onClick={handleNewCreateCampaignCancel}
                        className="create-new-campaign-cancel-btn"
                      >
                        <Text className="create-new-campaign-cancel-btn-text">
                          Cancel
                        </Text>
                      </Button>
                    </Col>
                    <Col span={12} className="create-new-capaign-col-confirm">
                      <Button
                        type="primary"
                        onClick={handleNewCreateCampaignConfirm}
                        className="create-new-campaign-confirm-btn"
                      >
                        <Text className="create-new-campaign-confirm-btn-text">
                          Confirm
                        </Text>
                      </Button>
                    </Col>
                  </Row>
                </div>
              </Modal>
            </div>
          </div>
          <section>
            <Row
              gutter={[16, 16]}
              justify="center"
              className="mobile-billboard-images-div"
            >
              <div className="mobile-image-scrollable-container">
                <Col lg={8} sm={24} xs={24} className="thumb-nail-parent-cols">
                  <div className="images-width-div">
                    <div
                      className={`image-wrapper ${
                        product?.image?.length > 0
                          ? "scrollable-col-container"
                          : "centered-col-container"
                      }`}
                    >
                      {product?.image?.length > 0 &&
                        product.image?.map((imgSrc, index) => (
                          <img
                            src={`${API_BASE_URL_IMAGE}` + imgSrc}
                            alt="Mobile-Billboard"
                            className="mobile-billboard-img"
                          />
                        ))}
                    </div>
                  </div>
                </Col>
              </div>
            </Row>
          </section>
          <div>
            <Card className="product-information-card">
              <Row gutter={[16, 16]} className="product-information-card-row">
                <Col span={12} product-information-card-col>
                  <Space direction="vertical" size="small">
                    <Text className="product-information-card-label">Type</Text>
                    <div className="product-information-card-value-div">
                      <Text className="product-information-card-value">
                        {product?.type || "N/A"}
                      </Text>
                    </div>
                  </Space>
                </Col>
                <Col span={12} product-information-card-col>
                  <Space direction="vertical" size="small">
                    <Text className="product-information-card-label">
                      Dimensions
                    </Text>
                    <div className="product-information-card-value-div">
                      <Text className="product-information-card-value">
                        {formatSize(product?.height)} X{" "}
                        {formatSize(product?.width)}
                      </Text>
                    </div>
                  </Space>
                </Col>
                <Col span={12} product-information-card-col>
                  <Space direction="vertical" size="small">
                    <Text className="product-information-card-label">
                      Address 1
                    </Text>
                    <div className="product-information-card-value-div">
                      <Text className="product-information-card-value">
                        {product?.address || "N/A"}
                      </Text>
                    </div>
                  </Space>
                </Col>
                <Col span={12} product-information-card-col>
                  <Space direction="vertical" size="small">
                    <Text className="product-information-card-label">
                      Address 2
                    </Text>
                    <div className="product-information-card-value-div">
                      <Text className="product-information-card-value">
                        {product?.city ? `${product.city}, ` : ""}
                        {product?.state ? `${product.state}, ` : ""}
                        {product?.country_name
                          ? `${product.country_name}, `
                          : ""}
                        {product?.zipcode ? product.zipcode : ""}
                        {!product?.city &&
                          !product?.state &&
                          !product?.country_name &&
                          !product?.zipcode &&
                          "N/A"}
                      </Text>
                    </div>
                  </Space>
                </Col>
                <Col span={12} product-information-card-col>
                  <Space direction="vertical" size="small">
                    <Text className="product-information-card-label">
                      Seller Id
                    </Text>
                    <div className="product-information-card-value-div">
                      <Text className="product-information-card-value">
                        {product?.sellerId || "N/A"}
                      </Text>
                    </div>
                  </Space>
                </Col>
                <Col span={12} product-information-card-col>
                  <Space direction="vertical" size="small">
                    <Text className="product-information-card-label">
                      Audited
                    </Text>
                    <div className="product-information-card-value-div">
                      <Text className="product-information-card-value">
                        {product?.audited || "N/A"}
                      </Text>
                    </div>
                  </Space>
                </Col>
                <Col span={12} product-information-card-col>
                  <Space direction="vertical" size="small">
                    <Text className="product-information-card-label">
                      Media HHI
                    </Text>
                    <div className="product-information-card-value-div">
                      <Text className="product-information-card-value">
                        {product?.mediaHhi || "N/A"}
                      </Text>
                    </div>
                  </Space>
                </Col>
                {product?.type !== "Digital" && product?.unitQty && (
                  <Col span={12} className="product-information-card-col">
                    <Space direction="vertical" size="small">
                      <Text className="product-information-card-label">
                        Unit Qty
                      </Text>
                      <div className="product-information-card-value-div">
                        <Text className="product-information-card-value">
                          {product?.unitQty || "N/A"}
                        </Text>
                      </div>
                    </Space>
                  </Col>
                )}
                <Col span={12} product-information-card-col>
                  <Space direction="vertical" size="small">
                    <Text className="product-information-card-label">
                      Install Cost
                    </Text>
                    <div className="product-information-card-value-div">
                      <Text className="product-information-card-value">
                        ${product?.installCost}.00
                      </Text>
                    </div>
                  </Space>
                </Col>
                <Col span={12} product-information-card-col>
                  <Space direction="vertical" size="small">
                    <Text className="product-information-card-label">
                      # of 4-week periods
                    </Text>
                    <div className="product-information-card-value-div">
                      <Text className="product-information-card-value">
                        {product?.rateCard || "N/A"}
                      </Text>
                    </div>
                  </Space>
                </Col>
                <Col span={12} product-information-card-col>
                  <Space direction="vertical" size="small">
                    <Text className="product-information-card-label">
                      Production Cost
                    </Text>
                    <div className="product-information-card-value-div">
                      <Text className="product-information-card-value">
                        ${product?.productioncost}.00
                      </Text>
                    </div>
                  </Space>
                </Col>
                <Col span={12} product-information-card-col>
                  <Space direction="vertical" size="small">
                    <Text className="product-information-card-label">
                      Tax Percentage (%)
                    </Text>
                    <div className="product-information-card-value-div">
                      <Text className="product-information-card-value">
                        {product?.taxPercentage || "N/A"}
                      </Text>
                    </div>
                  </Space>
                </Col>
                <Col span={12} product-information-card-col>
                  <Space direction="vertical" size="small">
                    <Text className="product-information-card-label">
                      AMP Bills
                    </Text>
                    <div className="product-information-card-value-div">
                      <Text className="product-information-card-value">
                        {product?.billing || "N/A"}
                      </Text>
                    </div>
                  </Space>
                </Col>
                <Col span={12} product-information-card-col>
                  <Space direction="vertical" size="small">
                    <Text className="product-information-card-label">
                      AMP Services
                    </Text>
                    <div className="product-information-card-value-div">
                      <Text className="product-information-card-value">
                        {product?.servicing || "N/A"}
                      </Text>
                    </div>
                  </Space>
                </Col>
                <Col span={12} product-information-card-col>
                  <Space direction="vertical" size="small">
                    <Text className="product-information-card-label">
                      Fixed/Variable
                    </Text>
                    <div className="product-information-card-value-div">
                      <Text className="product-information-card-value">
                        {product?.fix || "N/A"}
                      </Text>
                    </div>
                  </Space>
                </Col>
                <Col span={12} product-information-card-col>
                  <Space direction="vertical" size="small">
                    <Text className="product-information-card-label">
                      Product Direction
                    </Text>
                    <div className="product-information-card-value-div">
                      <Text className="product-information-card-value">
                        {product?.imgdirection || "N/A"}
                      </Text>
                    </div>
                  </Space>
                </Col>
                <Col span={12} product-information-card-col>
                  <Space direction="vertical" size="small">
                    <Text className="product-information-card-label">
                      Impression 18-49
                    </Text>
                    <div className="product-information-card-value-div">
                      <Text className="product-information-card-value">
                        {product?.firstImpression || "N/A"}
                      </Text>
                    </div>
                  </Space>
                </Col>
                <Col span={12} product-information-card-col>
                  <Space direction="vertical" size="small">
                    <Text className="product-information-card-label">
                      CPM A 18-Plus
                    </Text>
                    <div className="product-information-card-value-div">
                      <Text className="product-information-card-value">
                        {product?.firstcpm || "N/A"}
                      </Text>
                    </div>
                  </Space>
                </Col>
                <Col span={12} product-information-card-col>
                  <Space direction="vertical" size="small">
                    <Text className="product-information-card-label">
                      Impression 18-Plus
                    </Text>
                    <div className="product-information-card-value-div">
                      <Text className="product-information-card-value">
                        {product?.secondImpression || "N/A"}
                      </Text>
                    </div>
                  </Space>
                </Col>
                <Col span={12} product-information-card-col>
                  <Space direction="vertical" size="small">
                    <Text className="product-information-card-label">
                      CPM A 18-Plus
                    </Text>
                    <div className="product-information-card-value-div">
                      <Text className="product-information-card-value">
                        {product?.cpm || "N/A"}
                      </Text>
                    </div>
                  </Space>
                </Col>
                <Col span={12} product-information-card-col>
                  <Space direction="vertical" size="small">
                    <Text className="product-information-card-label">
                      Impression 25-54
                    </Text>
                    <div className="product-information-card-value-div">
                      <Text className="product-information-card-value">
                        {product?.thirdImpression || "N/A"}
                      </Text>
                    </div>
                  </Space>
                </Col>
                <Col span={12} product-information-card-col>
                  <Space direction="vertical" size="small">
                    <Text className="product-information-card-label">
                      CPM A 25-54
                    </Text>
                    <div className="product-information-card-value-div">
                      <Text className="product-information-card-value">
                        {product?.thirdcpm || "N/A"}
                      </Text>
                    </div>
                  </Space>
                </Col>
                <Col span={12} product-information-card-col>
                  <Space direction="vertical" size="small">
                    <Text className="product-information-card-label">
                      Impression (HA25 - HA54)
                    </Text>
                    <div className="product-information-card-value-div">
                      <Text className="product-information-card-value">
                        {product?.forthImpression || "N/A"}
                      </Text>
                    </div>
                  </Space>
                </Col>
                <Col span={12} product-information-card-col>
                  <Space direction="vertical" size="small">
                    <Text className="product-information-card-label">
                      CPM H 25 - 54
                    </Text>
                    <div className="product-information-card-value-div">
                      <Text className="product-information-card-value">
                        {product?.forthcpm || "N/A"}
                      </Text>
                    </div>
                  </Space>
                </Col>
                <Col span={12} product-information-card-col>
                  <Space direction="vertical" size="small">
                    <Text className="product-information-card-label">
                      Cancellation Policy
                    </Text>
                    <div className="product-information-card-value-div">
                      <Text className="product-information-card-value">
                        {product?.cancellation_policy || "N/A"}
                      </Text>
                    </div>
                  </Space>
                </Col>
                <Col span={12} product-information-card-col>
                  <Space direction="vertical" size="small">
                    <Text className="product-information-card-label">
                      Payment Terms
                    </Text>
                    <div className="product-information-card-value-div">
                      <Text className="product-information-card-value">
                        {product?.cancellation_terms || "N/A"}
                      </Text>
                    </div>
                  </Space>
                </Col>
                <Col span={12} product-information-card-col>
                  <Space direction="vertical" size="small">
                    <Text className="product-information-card-label">
                      Restrictions
                    </Text>
                    <div className="product-information-card-value-div">
                      <Text className="product-information-card-value">
                        {product?.notes || "N/A"}
                      </Text>
                    </div>
                  </Space>
                </Col>
                <Col span={12} product-information-card-col>
                  <Space direction="vertical" size="small">
                    <Text className="product-information-card-label">
                      Facing
                    </Text>
                    <div className="product-information-card-value-div">
                      <Text className="product-information-card-value">
                        {product?.direction || "N/A"}
                      </Text>
                    </div>
                  </Space>
                </Col>
                <Col span={12} product-information-card-col>
                  <Space direction="vertical" size="small">
                    <Text className="product-information-card-label">
                      Spot Length
                    </Text>
                    <div className="product-information-card-value-div">
                      <Text className="product-information-card-value">
                        {product?.spotLength || "N/A"}
                      </Text>
                    </div>
                  </Space>
                </Col>
                <Col span={12} product-information-card-col>
                  <Space direction="vertical" size="small">
                    <Text className="product-information-card-label">
                      Loop Length
                    </Text>
                    <div className="product-information-card-value-div">
                      <Text className="product-information-card-value">
                        {product?.ageloopLength || "N/A"}
                      </Text>
                    </div>
                  </Space>
                </Col>
                <Col span={12} product-information-card-col>
                  <Space direction="vertical" size="small">
                    <Text className="product-information-card-label">
                      Latitude
                    </Text>
                    <div className="product-information-card-value-div">
                      <Text className="product-information-card-value">
                        {product?.lat || "N/A"}
                      </Text>
                    </div>
                  </Space>
                </Col>
                <Col span={12} product-information-card-col>
                  <Space direction="vertical" size="small">
                    <Text className="product-information-card-label">
                      Longitude
                    </Text>
                    <div className="product-information-card-value-div">
                      <Text className="product-information-card-value">
                        {product?.lng || "N/A"}
                      </Text>
                    </div>
                  </Space>
                </Col>
                <Col span={12} product-information-card-col>
                  <Space direction="vertical" size="small">
                    <Text className="product-information-card-label">
                      Flip Length
                    </Text>
                    <div className="product-information-card-value-div">
                      <Text className="product-information-card-value">
                        {product?.fliplength || "N/A"}
                      </Text>
                    </div>
                  </Space>
                </Col>
                <Col span={12} product-information-card-col>
                  <Space direction="vertical" size="small">
                    <Text className="product-information-card-label">
                      Loop Length
                    </Text>
                    <div className="product-information-card-value-div">
                      <Text className="product-information-card-value">
                        {product?.ageloopLength || "N/A"}
                      </Text>
                    </div>
                  </Space>
                </Col>
                <Col span={12} product-information-card-col>
                  <Space direction="vertical" size="small">
                    <Text className="product-information-card-label">
                      Comments
                    </Text>
                    <div className="product-information-card-value-div">
                      <Text className="product-information-card-value">
                        {product?.Comments || "N/A"}
                      </Text>
                    </div>
                  </Space>
                </Col>
                <Col span={12} product-information-card-col>
                  <Space direction="vertical" size="small">
                    <Text className="product-information-card-label">
                      Location Description
                    </Text>
                    <div className="product-information-card-value-div">
                      <Text className="product-information-card-value">
                        {product?.locationDesc || "N/A"}
                      </Text>
                    </div>
                  </Space>
                </Col>
              </Row>
            </Card>
          </div>
        </div>
        {!isBillboard && (
          <Card className="fixed-addto-campaign-btn-card">
            <Row justify="space-between" align="middle">
              <Col span={16} className="description-addto-campaign-btn">
                <div>
                  <Text className="description-addto-campaign-cost-text">
                    (Includes all taxes, installation fees, and manufacturing
                    costs for the selected days)
                  </Text>
                </div>
              </Col>
              <Col span={8} style={{ textAlign: "right" }}>
                <div className="description-addto-campaign-cost-price">
                  <Title
                    level={2}
                    className="description-addto-campaign-cost-price"
                  >
                    {formatToUSCurrency(
                      parseFloat(
                        selectedDatesForCampaign[
                          selectedDatesForCampaign.length - 1
                        ]?.diff(selectedDatesForCampaign[0], "day") +
                          1 >
                          0
                          ? totalPrice
                          : 0 || 0,
                      ).toFixed(2),
                    )}
                  </Title>
                </div>
              </Col>
            </Row>
            <Row>
              <Col span={24} className="add-to-campaign-btn-version">
                <Button
                  type="primary"
                  // disabled={!isLoggedIn}
                  className={`mobile-add-to-campaign-btn ${
                    !isLoggedIn ? "disabled-button" : ""
                  }`}
                  onClick={handleAddCampaign}
                >
                  Add to Campaign
                </Button>
              </Col>
            </Row>
          </Card>
        )}

        <div className="warningPopup-div">
          <Modal
            open={warningPopup}
            closable={false}
            footer={false}
            className="warningPopup-modal"
            centered
          >
            <div className="oops-container">
              <Row justify="center" align="middle">
                <Image src={warningIcon} preview={false} alt="Warning Icon" />
              </Row>
              <Row>
                <Text className="oops-msg-test">
                  Oops! Please select the campaign and dates to proceed.
                </Text>
              </Row>
              <Row gutter={[16, 16]}>
                <Button
                  type="primary"
                  onClick={() => setWarningPopup(false)}
                  className="cancel-calendar-btn"
                >
                  <Text className="cancel-calendar-btn-text">Close</Text>
                </Button>
              </Row>
            </div>
          </Modal>
        </div>
        <div>
          <LoginAlert
            loginPopoverVisible={loginPopoverVisible}
            setLoginPopoverVisible={setLoginPopoverVisible}
          />
        </div>
      </div>
      {isLoading && (
        <div className="product-version-spin">
          <Spin size="large" fullscreen />
        </div>
      )}
    </>
  );
};
export default ProductDetailsCard;
